import { Prismic } from '@landsbankinn/prismic';
import { AccordionItem, AccordionList } from '@landsbankinn/ui';
import React from 'react';
import { QuartersContainer } from './QuartersContainer';
import { SlicesContainer } from './SlicesContainer';
import { TextWithImagesContainer } from './TextWithImagesContainer';

interface IProps {
  fields: IField[];
  is_open: boolean;
  single_display?: boolean;
}

interface IField {
  page: IItem;
}

interface IItem {
  page_title: Prismic.RichText;
  body: any;
}

const Slices = ({ data }: { data: any }) => {
  enum SliceType {
    TEXT_WITH_IMAGES = 'text_with_images',
    QUARTERS = 'quarters',
  }

  return (
    <>
      {(data || []).map((s: any, i: number) => {
        const key = `slice${s.type}-${i}`;
        const props = { ...s, ...s.primary };

        switch (s.type) {
          case SliceType.QUARTERS:
            return (
              <QuartersContainer key={key} hasContainer={false} {...props} />
            );
          case SliceType.TEXT_WITH_IMAGES:
            return (
              <TextWithImagesContainer
                key={key}
                hasContainer={false}
                {...props}
              />
            );
          default:
            if (s.type) {
              console.warn('No slice available for %s %o', s.type, s); // tslint:disable-line
            }
            return null;
        }
      })}
    </>
  );
};

const renderFaqItem = ({ page }: IField, i: number) => {
  const slices = page?.body;

  return (
    <AccordionItem
      key={`${i}-${Prismic.text(page?.page_title)}`}
      title={Prismic.text(page?.page_title) ?? ''}
      content={<SlicesContainer data={slices} />}
      isFullWidth
      lineSeperator
    />
  );
};

export const AccordionContainer = ({
  fields,
  is_open = false,
  single_display = false,
}: IProps) => {
  const items = fields?.filter(({ page }) => page);
  if (!items.length) {
    return null;
  }
  return (
    <AccordionList firstOpen={is_open} singleDisplay={single_display}>
      {items.map(renderFaqItem)}
    </AccordionList>
  );
};
